"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "invokeSafe", {
    enumerable: true,
    get: function() {
        return invokeSafe;
    }
});
const invokeSafe = (fn)=>{
    try {
        const data = fn();
        return [
            data,
            null
        ];
    } catch (throwable) {
        return [
            null,
            throwable
        ];
    }
};
